import { Modal } from "react-bootstrap";

export const TermsAndConditionsModal = (props) => {
  const { isModalVisible, setIsModalVisible } = props;
  return (
    <Modal
      show={isModalVisible}
      onHide={() => setIsModalVisible(false)}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>Terms and Conditions for Reservations</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>TERMS AND CONDITIONS FOR RESERVATIONS</h4>
        <p>(Applicable when booking via Syncera Booking Engine)</p>
        <ol>
          <li>
            <strong>Overview:</strong> By using the Syncera Booking Engine to
            make a reservation, you agree to all the terms and conditions
            outlined herein. These terms apply to all reservation transactions
            conducted through the system.
          </li>
          <li>
            <strong>Reservation Confirmation:</strong> Reservations are only
            confirmed upon receiving a confirmation email from the hotel. All
            booking requests are subject to room availability at the time of
            booking.
          </li>
          <li>
            <strong>Pricing Policy:</strong>
            <ul>
              <li>
                Room rates displayed on the Syncera Booking Engine include taxes
                and fees unless otherwise noted.
              </li>
              <li>
                Promotions or discount codes apply only at the time of booking
                and cannot be combined with other offers.
              </li>
              <li>
                Rates are subject to change without prior notice but do not
                apply to confirmed reservations.
              </li>
            </ul>
          </li>
          <li>
            <strong>Payment Policy:</strong>
            <ul>
              <li>
                Some reservations require immediate payment upon booking; others
                allow payment at the hotel.
              </li>
              <li>
                Accepted payment methods (credit card, bank transfer, etc.) will
                be specified in the system.
              </li>
              <li>
                If payment transactions fail, the hotel reserves the right to
                cancel the booking.
              </li>
            </ul>
          </li>
          <li>
            <strong>Cancellation and Modification Policy:</strong>
            <ul>
              <li>
                The cancellation or modification policy will be clearly
                displayed at the time of booking and in the confirmation email.
              </li>
              <li>
                Guests must contact the hotel at least [hotel-specific
                hours/days] before the check-in date to make changes or cancel.
              </li>
              <li>
                Cancellation or no-show fees will be applied according to the
                specific booking policy.
              </li>
            </ul>
          </li>
          <li>
            <strong>Special Requests:</strong> Special requests (e.g., high
            floor, extra beds, adjacent rooms) will be accommodated to the best
            of our ability but are not guaranteed.
          </li>
          <li>
            <strong>Privacy Policy:</strong>
            <ul>
              <li>
                The hotel is committed to protecting your privacy in accordance
                with applicable laws.
              </li>
              <li>
                Personal information will only be used to process your
                reservation and will not be shared with third parties, except
                for authorized payment partners.
              </li>
            </ul>
          </li>
          <li>
            <strong>Transaction Security:</strong>
            <ul>
              <li>
                All booking transactions via Syncera Booking Engine are
                conducted on a secure system (SSL - Secure Sockets Layer).
              </li>
              <li>
                Payment details, including credit card information, are
                encrypted to ensure complete security.
              </li>
              <li>
                Your credit card details may be required to guarantee your
                reservation. Charges will only be applied per the cancellation
                or no-show policy specified during booking.
              </li>
            </ul>
          </li>
          <li>
            <strong>Other Conditions:</strong> All disputes arising will be
            resolved in accordance with the laws of [the local jurisdiction
            where the hotel is located]. By using the system, you agree to
            comply with all these terms and conditions.
          </li>
          <li>
            <strong>Contact Support:</strong> If you have any questions or
            issues, please contact:
            <ul>
              <li>Email: [hotel email]</li>
              <li>Phone: [hotel phone number]</li>
            </ul>
          </li>
          <li>
            <strong>Privacy Policy:</strong>
            <ul>
              <li>
                <strong>Collection of Personal Information:</strong> We collect
                the following types of information, including but not limited
                to:
                <ul>
                  <li>Full name, address, phone number, and email.</li>
                  <li>
                    Payment details (credit card or bank account information).
                  </li>
                  <li>Special requests or preferences (if any).</li>
                </ul>
              </li>
              <li>
                <strong>Use of Personal Information:</strong> Your personal
                information will be used for the following purposes:
                <ul>
                  <li>Confirming and managing reservations.</li>
                  <li>Sending promotional information and special offers.</li>
                  <li>Collecting feedback to improve service quality.</li>
                  <li>
                    Supporting additional services (e.g., visas, airport
                    transfers).
                  </li>
                  <li>Inviting participation in surveys or market research.</li>
                </ul>
              </li>
              <li>
                <strong>Sharing of Personal Information:</strong> Your data may
                be shared with:
                <ul>
                  <li>
                    Accommodation partners: To ensure the service meets your
                    requirements.
                  </li>
                  <li>
                    Service providers: Including technical, payment, and
                    customer management services.
                  </li>
                  <li>Legal authorities: As required by law.</li>
                  <li>
                    International transfers: Data may be transferred to other
                    countries, subject to data protection regulations.
                  </li>
                </ul>
              </li>
              <li>
                <strong>Use of Cookies:</strong>
                <ul>
                  <li>
                    <strong>Purpose:</strong> Cookies help enhance user
                    experience and monitor website activity.
                  </li>
                  <li>
                    <strong>Management:</strong> You can disable cookies via
                    your browser settings, but some functionalities may be
                    affected.
                  </li>
                </ul>
              </li>
              <li>
                <strong>Data Security:</strong> Personal data is protected
                through technical and organizational measures to prevent
                unauthorized access or data loss.
              </li>
              <li>
                <strong>Data Retention:</strong> Data will be retained as long
                as necessary to:
                <ul>
                  <li>Provide services.</li>
                  <li>Fulfill legal obligations.</li>
                  <li>Protect the hotel's business interests.</li>
                </ul>
              </li>
              <li>
                <strong>Your Rights:</strong> You have the right to:
                <ul>
                  <li>
                    Access, amend, or request deletion of your personal data.
                  </li>
                  <li>
                    Restrict data processing or opt-out of promotional
                    communications.
                  </li>
                  <li>Submit your request via email: privacy@syncera.com.</li>
                </ul>
              </li>
              <li>
                <strong>Exercising Your Rights:</strong> Your requests will be
                processed per applicable laws and regulations.
              </li>
            </ul>
          </li>
          <li>
            <strong>Updates to Terms and Policies:</strong> The terms and
            policies may be updated. Changes will be announced on the website
            with the new effective date.
          </li>
        </ol>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => setIsModalVisible(false)}
        >
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};
